/** @tsx tsx */

import { Text } from "@nike/eds";

interface DateTimeCellProps {
  date: string;
}

export function DateTimeCell({ date }: DateTimeCellProps): JSX.Element {
  const dateObj = new Date(date);
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  const month = dateObj.toLocaleDateString("en", { month: "long" });
  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();
  const timezone = dateObj.toString().split("(")[1];

  const formattedDate = `${month} ${day}, ${year}`;
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHour = ampm === "PM" ? hours - 12 : hours;
  const formattedTime = `${formattedHour}:${minutes}${ampm} (${timezone}`;

  return (
    <>
      <Text>{formattedDate}</Text>
      <Text color="text-secondary">{formattedTime}</Text>
    </>
  );
}
